
const digest = 'ce8d1b5d510925292feed0e759e32c76ec71cb8d4e7bc1c289240eb5f92ba2fe';
const classes = {"inline":"_inline_1hzph_1","bold":"_bold_1hzph_7"};
const css = `._inline_1hzph_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

._bold_1hzph_7 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  